import axios from "axios";
import { API_URL } from "../constants/api";
import { useQuery } from "react-query";

const APIURL = axios.create({
  baseURL: API_URL,
});

const IT = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/it/companies`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowIT = (uuid, lang) => {
  return useQuery(`show_it-${lang}`, () => IT(uuid, lang));
};

const ITs = async (uuid, e_uuid, lang) => {
  return await APIURL.get(`/${uuid}/it/categories/${e_uuid}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowITs = (uuid, e_uuid, lang) => {
  return useQuery(`its-${lang}-${e_uuid}`, () => ITs(uuid, e_uuid, lang));
};
